import { FormattedMessage } from 'react-intl';
import React, { Fragment } from 'react';
import { imageSet } from 'Components/helper/Images';
import { Image } from 'Components/commonComponents';
import {
  language,
  LANG_KR,
  LANG_HK,
  LANG_JP,
  LANG_TWQ,
  showBoxShotImage,
  CLASSIC_LENS_TAB,
  showProductDetailBuyModal,
  showProductExternalBuy,
} from 'Root/constants';
import { BtnBuyModal } from 'Components/commonComponents';

const external_cart_standard = 'external_cart_standard';

const BoxShot = ({ boxShot, className }) => (
  <Fragment>
    {boxShot && showBoxShotImage && (
      <Image
        className={`img-responsive ${className}`}
        src={imageSet[boxShot]}
      />
    )}
  </Fragment>
);

const Description = ({
  lens: {
    name,
    promotion,
    big_img,
    small_img,
    box_img,
    box_shot,
    lens_tutorial_img,
    specs,
    external_buy_img
  },
  selectedLensType,
}) => (
  <div className="tabs--content tabs--content__lens">
    <div className="tabs--content__left">
      {(language === LANG_KR || language === LANG_HK || language === LANG_TWQ) ? (
        <Fragment>
          <Image className="img-responsive" src={imageSet[lens_tutorial_img]} />
          {showProductExternalBuy && (
            <Fragment>
              <a className={`tabs--item tabs--color__${selectedLensType} tabs--item__buy tabs--color__buyModel`} href={selectedLensType === CLASSIC_LENS_TAB ? process.env.REACT_APP_BUY_CLASSIC_LENS_EXTERNAL_LINK:process.env.REACT_APP_BUY_FRESH_LENS_EXTERNAL_LINK} target='_blank'>
                {imageSet[external_buy_img] && (
                  <Image className='img-responsive icons--cart' src={imageSet[external_buy_img]} />
                )}
                <FormattedMessage id="products.external_buy" defaultMessage="BUY"/>
              </a>
            </Fragment>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <figure className="tabs--content__left-first">
            <Image
              className="img-responsive big-lens-image"
              src={imageSet[big_img]}
            />
            {showProductExternalBuy && (
              <Fragment>
                <a className={`tabs--item tabs--color__${selectedLensType} tabs--item__buy tabs--color__buyModel`} href={selectedLensType === CLASSIC_LENS_TAB ? process.env.REACT_APP_BUY_CLASSIC_LENS_EXTERNAL_LINK:process.env.REACT_APP_BUY_FRESH_LENS_EXTERNAL_LINK} target='_blank'>
                {process.env.REACT_APP_REGION==='EMEA'?'':<Image className='img-responsive icons--cart' src={imageSet[external_cart_standard]} />}
                  <FormattedMessage id="products.external_buy"
                  defaultMessage="BUY"/>
                </a>
              </Fragment>
            )}
            {showProductDetailBuyModal && <BtnBuyModal />}
            {selectedLensType === CLASSIC_LENS_TAB && (
              <Image className="img-responsive" src={imageSet[box_img]} />
            )}
            <BoxShot boxShot={box_shot} className="boxshot-mobile" />
          </figure>
          <div className="tabs--content__left-second">
            <div className="tabs--content__product-title">
              <FormattedMessage
                id="product_info.about"
                defaultMessage="About Our Lenses"
              />
            </div>
            <div
              className="tabs--content__product-name"
              dangerouslySetInnerHTML={{ __html: name }}
            />
            <div
              className="tabs--content__product-promotion"
              dangerouslySetInnerHTML={{ __html: promotion }}
            />

            <figure className="tabs--content__product-icon-detail">
              {small_img && language !== LANG_JP && (
                <Image className="img-responsive" src={imageSet[small_img]} />
              )}
              <BoxShot boxShot={box_shot} className="boxshot-desktop" />
            </figure>
          </div>
        </Fragment>
      )}
    </div>
    {/* --------seperate List component------ */}
    <div className="tabs--content__right">
      <ul className="tabs--content__product-specs">
        {specs.map((item, index) => (
          <li className="tabs--content__product-specs-item" key={index}>
            <figure className="tabs--content__product-specs-left">
              {imageSet[item.icon] && (
                <img className="img-responsive" src={imageSet[item.icon]} />
              )}
            </figure>
            <div className="tabs--content__product-specs-right">
              <div
                className="tabs--content__product-specs-title spec-title"
                dangerouslySetInnerHTML={{ __html: item.title }}
              />
              <ul className="tabs--content__product-specs-list">
                {item.desc.map((descItem, descIndex) => (
                  <li
                    key={descIndex}
                    dangerouslySetInnerHTML={{ __html: descItem }}
                  />
                ))}
              </ul>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default Description;
